"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertisingSwitch = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const inputswitch_1 = require("primereact/inputswitch");
const react_i18next_1 = require("react-i18next");
const advertising_module_scss_1 = __importDefault(require("../advertising.module.scss"));
const AdvertisingSwitch = ({ checked, machineName, onChange, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("span", { className: advertising_module_scss_1.default.switchCell, children: (0, jsx_runtime_1.jsx)(inputswitch_1.InputSwitch, { checked: checked, onChange: (e) => onChange(Boolean(e.value)), "aria-label": t('advertising.machines.toggleAria', {
                machine: machineName,
            }) }) }));
};
exports.AdvertisingSwitch = AdvertisingSwitch;
